module.exports = __webpack_public_path__ + "static/media/吴斐然@2x.983e8951.png";